import { createFileRoute } from "@tanstack/react-router";

import { loaderHandler } from "src/lib/loaderHandler";
import { AdminBillingPage } from "src/pages/AdminBillingPage";
import {
  appFeaturesQueryOptions,
  billingCatalogQueryOptions,
} from "src/queries/adminBilling";

export const Route = createFileRoute("/_auth/_admin/admin/billing/")({
  component: AdminBillingPage,
  ssr: true,
  async loader({ context }) {
    return await loaderHandler(async () => {
      await Promise.all([
        context.queryClient.query({
          ...billingCatalogQueryOptions(),
          staleTime: "static",
        }),
        context.queryClient.query({
          ...appFeaturesQueryOptions(),
          staleTime: "static",
        }),
      ]);

      return { data: {} };
    });
  },
});
